The upper limit of webhook requests to return from the start of the list.

Defaults to 10 if neither `first` nor `last` are specified.
Excess webhook requests will be trimmed from the end of the list.

`first` and `last` cannot be specified in the same query.
